import { createSlice } from '@reduxjs/toolkit';
import { createSession, editSession, getAllSessions, getSessionById, deleteSession } from './sessionActions';

const initialState = {
    loading: false,
    data: [],
    error: null
};

const authSlice = createSlice({
    name: 'session',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // create session
            .addCase(createSession.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createSession.fulfilled, (state, { payload }) => {
                state.loading = false;

            })
            .addCase(createSession.rejected, (state, { payload }) => {
                state.error = payload?.error || 'Add session failed';
                state.loading = false;
            })

            // get all sessions
            .addCase(getAllSessions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllSessions.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.data = payload;
                state.error = null;
            })
            .addCase(getAllSessions.rejected, (state, { payload }) => {
                state.error = payload?.error || 'Fetch sessions failed';
                state.loading = false;
            })

            // edit session
            .addCase(editSession.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(editSession.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(editSession.rejected, (state, { payload }) => {
                state.error = payload?.error || 'Edit session failed';
                state.loading = false;
            })

            // get all sessions
            .addCase(getSessionById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSessionById.fulfilled, (state, { payload }) => {
                state.loading = false;
                // state.data = payload;
                state.error = null;
            })
            .addCase(getSessionById.rejected, (state, { payload }) => {
                state.error = payload?.error || 'Delete failed';
                state.loading = false;
            })

            //delete sessions
            .addCase(deleteSession.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteSession.fulfilled, (state, { payload }) => {
                state.loading = false;
                // state.data = payload;
                state.error = null;
            })
            .addCase(deleteSession.rejected, (state, { payload }) => {
                state.error = payload?.error || 'Delete failed';
                state.loading = false;
            })
    }
});

export const { } = authSlice.actions;
export default authSlice.reducer; // This is important
